/* eslint-disable @typescript-eslint/ban-ts-comment */
import { KeyValue, KeyValuePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EngFormControl } from '../../models';
import { FormInputComponent } from '../form-input/form-input.component';

@Component({
    selector: 'lib-form-inputs',
    templateUrl: './form-inputs.component.html',
    standalone: true,
    imports: [FormInputComponent, KeyValuePipe]
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class FormInputsComponent<T = any> {
    @Input() filter!: boolean;
    @Input() form!: FormGroup;
    @Input() controls!:
        | Array<EngFormControl<T>>
        | {
              [key: string]: EngFormControl<T>;
          };

    keyvaluePipeCompareFn(a: KeyValue<string, EngFormControl<T>>, b: KeyValue<string, EngFormControl<T>>) {
        // @ts-ignore
        if (a.value.index > b.value.index) {
            return 1;
        }
        // @ts-ignore
        if (a.value.index < b.value.index) {
            return -1;
        }
        return 0;
    }
}
